import axios from "axios";
import { ApiHost } from "../utils/ApiConfig";

const ISZTAR_VALIDATION_TIMEOUT_MS = 30 * 1000;
const ISZTAR_RESULTS = ["TAK", "NIE", "NIEPEŁNE DANE"];
const ISZTAR_RESULTS_REQUIRING_CORRECTION = ["NIE", "NIEPEŁNE DANE"];

const isRecommendation = (recommendation) =>
  typeof recommendation?.code === "string" &&
  typeof recommendation?.description === "string";

const isValidationResponse = (response) =>
  ISZTAR_RESULTS.includes(response?.result) &&
  typeof response?.result_message === "string" &&
  Array.isArray(response?.recommendations) &&
  response.recommendations.every(isRecommendation);

export const requiresIsztarCorrection = (validation) =>
  ISZTAR_RESULTS_REQUIRING_CORRECTION.includes(validation?.result);

export const validateIsztarCode = async (code, description, accessToken) => {
  try {
    const response = await axios.post(
      ApiHost + "/chat/isztar-validation",
      { code, description },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        timeout: ISZTAR_VALIDATION_TIMEOUT_MS,
      },
    );

    if (!isValidationResponse(response.data)) {
      throw new Error("Walidator kodów ISZTAR zwrócił nieprawidłową odpowiedź.");
    }

    return response.data;
  } catch (error) {
    const message = error.response?.data?.msg;
    if (typeof message === "string" && message.trim()) {
      throw new Error(message.trim());
    }
    if (error.code === "ECONNABORTED") {
      throw new Error("Walidacja kodu przez AI przekroczyła dozwolony czas.");
    }
    if (error instanceof Error) throw error;
    throw new Error("Nie udało się połączyć z walidatorem kodów ISZTAR.");
  }
};
